"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var theme_1 = require("../../utils/theme");
var ApIcon_1 = require("../ApIcon");
var ApSimpleDropdown_styles_1 = require("./ApSimpleDropdown.styles");
var DEFAULT_ICON_SIZE = '18px';
var ApSimpleDropdownLabel = React.forwardRef(function (_a, ref) {
    var iconProps = _a.iconProps, iconName = _a.iconName, _b = _a.text, text = _b === void 0 ? '' : _b, isOpen = _a.isOpen, disabled = _a.disabled, rest = __rest(_a, ["iconProps", "iconName", "text", "isOpen", "disabled"]);
    return (React.createElement(ApSimpleDropdown_styles_1.ApSimpleDropdownLabelContainer, __assign({}, rest, { ref: ref, disabled: disabled, isOpen: isOpen }),
        iconName && (React.createElement(ApIcon_1.ApIcon, __assign({ iconName: iconName, iconSize: DEFAULT_ICON_SIZE }, iconProps, { iconColor: disabled ? theme_1.colors.grey5 : theme_1.colors.grey8 }))),
        React.createElement(ApSimpleDropdown_styles_1.ApSimpleDropdownLabelText, { disabled: disabled }, text),
        React.createElement(ApIcon_1.ApIcon, { iconName: "caret", iconColor: theme_1.colors.grey5 })));
});
exports.default = ApSimpleDropdownLabel;
//# sourceMappingURL=ApSimpleDropdownLabel.js.map